export const ZONES = [
  {
    slug: "nosy-be", name: "Nosy Be", pin: { x: 78, y: 105 },
    img: "https://images.unsplash.com/photo-1519046904884-53103b34b206?w=1200&q=75&auto=format&fit=crop",
    it: {
      tagline: "L'isola dei profumi, la meta turistica n.1",
      profile: "Turismo balneare e residenziale",
      description: "Nosy Be è la destinazione turistica più nota del Madagascar: spiagge bianche, mare cristallino, piantagioni di ylang-ylang e un aeroporto internazionale con voli diretti stagionali dall'Italia.\n\nÈ la zona con il mercato immobiliare più liquido del Paese: più cara, ma anche la più semplice da valorizzare con affitti turistici e rivendite.",
      access: "Voli diretti stagionali da Milano e Roma; via Antananarivo tutto l'anno.",
      climate: "Tropicale; stagione secca maggio–ottobre, umida novembre–aprile.",
      price: "Terreni da 15–40 €/m²; fronte mare da 60 €/m² in su.",
      best: "Investimento turistico, casa vacanze, residence.",
    },
    en: {
      tagline: "The perfume island, the no.1 tourist destination",
      profile: "Beach tourism and residential",
      description: "Nosy Be is Madagascar's best-known tourist destination: white beaches, crystal-clear sea, ylang-ylang plantations and an international airport with seasonal direct flights from Italy.\n\nIt has the most liquid property market in the country: pricier, but also the easiest to monetise with holiday rentals and resales.",
      access: "Seasonal direct flights from Milan and Rome; via Antananarivo all year.",
      climate: "Tropical; dry season May–October, wet November–April.",
      price: "Land from €15–40/m²; beachfront from €60/m² up.",
      best: "Tourism investment, holiday home, residences.",
    },
  },
  {
    slug: "sainte-marie", name: "Sainte-Marie", pin: { x: 322, y: 285 },
    img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&q=75&auto=format&fit=crop",
    it: {
      tagline: "L'isola delle balene, autentica e tranquilla",
      profile: "Eco-turismo e residenza tranquilla",
      description: "Île Sainte-Marie (Nosy Boraha) è una lunga isola sulla costa est, famosa per il passaggio delle megattere tra giugno e settembre. Atmosfera intatta, prezzi più bassi di Nosy Be.\n\nMeno servita ma in crescita: interessa a chi cerca eco-lodge e progetti piccoli in un contesto ancora autentico.",
      access: "Volo da Antananarivo o traghetto da Soanierana-Ivongo.",
      climate: "Umido tutto l'anno, esposto ai cicloni: costruire con criterio.",
      price: "Terreni da 8–20 €/m²; fronte mare da 25 €/m².",
      best: "Eco-lodge, ritiri, residenza lenta.",
    },
    en: {
      tagline: "The whale island, authentic and quiet",
      profile: "Eco-tourism and quiet living",
      description: "Île Sainte-Marie (Nosy Boraha) is a long island off the east coast, famous for humpback whales between June and September. Unspoilt atmosphere, lower prices than Nosy Be.\n\nLess serviced but growing: suits eco-lodges and small projects in a still-authentic setting.",
      access: "Flight from Antananarivo or ferry from Soanierana-Ivongo.",
      climate: "Humid all year, cyclone-exposed: build accordingly.",
      price: "Land from €8–20/m²; beachfront from €25/m².",
      best: "Eco-lodges, retreats, slow living.",
    },
  },
  {
    slug: "diego-suarez", name: "Diego Suarez", pin: { x: 232, y: 42 },
    img: "https://images.unsplash.com/photo-1505142468610-359e7d316be0?w=1200&q=75&auto=format&fit=crop",
    it: {
      tagline: "La grande baia del nord",
      profile: "Turismo d'avventura e nautica",
      description: "Antsiranana, detta Diego Suarez, affaccia su una delle baie naturali più grandi del mondo. Natura spettacolare tra mare, montagne d'Ambra e parchi, con turismo di nicchia in crescita.\n\nPrezzi ancora contenuti e buona disponibilità di terreni con vista: interessante per chi arriva prima degli altri.",
      access: "Volo da Antananarivo (1h45) o via Nosy Be.",
      climate: "Secco e ventilato; ideale per vela e kitesurf.",
      price: "Terreni da 6–18 €/m²; vista baia da 20 €/m².",
      best: "Boutique hotel, nautica, residenza.",
    },
    en: {
      tagline: "The great bay of the north",
      profile: "Adventure tourism and sailing",
      description: "Antsiranana, known as Diego Suarez, overlooks one of the largest natural bays in the world. Spectacular nature between sea, Amber Mountain and parks, with growing niche tourism.\n\nPrices still low and good supply of view plots: interesting for early movers.",
      access: "Flight from Antananarivo (1h45) or via Nosy Be.",
      climate: "Dry and windy; ideal for sailing and kitesurfing.",
      price: "Land from €6–18/m²; bay view from €20/m².",
      best: "Boutique hotels, sailing, residence.",
    },
  },
  {
    slug: "antananarivo", name: "Antananarivo", pin: { x: 195, y: 385 },
    img: "https://images.unsplash.com/photo-1524661135-423995f22d0b?w=1200&q=75&auto=format&fit=crop",
    it: {
      tagline: "La capitale, il cuore economico",
      profile: "Residenziale urbano e commerciale",
      description: "Antananarivo è la capitale e il centro degli affari: qui sono notai, banche, uffici e il mercato immobiliare urbano più attivo.\n\nInteressa a chi investe in residenziale cittadino o ha bisogno di una base operativa per attività nel Paese.",
      access: "Aeroporto internazionale di Ivato, hub di tutti i voli interni.",
      climate: "Altitudine 1.300 m: clima mite, inverni freschi e secchi.",
      price: "Molto variabili per quartiere; da valutare caso per caso.",
      best: "Residenziale urbano, uffici, base operativa.",
    },
    en: {
      tagline: "The capital, the economic heart",
      profile: "Urban residential and commercial",
      description: "Antananarivo is the capital and business centre: home to notaries, banks, offices and the country's most active urban property market.\n\nIt suits urban residential investors or anyone needing an operational base in the country.",
      access: "Ivato international airport, hub for all domestic flights.",
      climate: "1,300 m altitude: mild climate, cool dry winters.",
      price: "Highly variable by district; case by case.",
      best: "Urban residential, offices, operational base.",
    },
  },
  {
    slug: "tamatave", name: "Tamatave e costa est", pin: { x: 275, y: 372 },
    img: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=1200&q=75&auto=format&fit=crop",
    it: {
      tagline: "Il porto e le spiagge della costa est",
      profile: "Misto: balneare e produttivo",
      description: "Toamasina (Tamatave) è il primo porto del Paese; a nord, Foulpointe e Mahambo offrono spiagge lagunari amate dai malgasci. Costa verde e piovosa, con canale di Pangalanes.\n\nPrezzi accessibili e domanda interna: un mercato diverso da quello turistico internazionale, da capire con guide locali.",
      access: "Volo o strada RN2 da Antananarivo (350 km).",
      climate: "Piovoso e umido; stagione ciclonica gennaio–marzo.",
      price: "Terreni da 4–12 €/m²; laguna da 15 €/m².",
      best: "Residenza, piccolo turismo, attività legate al porto.",
    },
    en: {
      tagline: "The port and the east coast beaches",
      profile: "Mixed: seaside and productive",
      description: "Toamasina (Tamatave) is the country's main port; to the north, Foulpointe and Mahambo offer lagoon beaches loved by Malagasy people. Green, rainy coast with the Pangalanes canal.\n\nAffordable prices and domestic demand: a market different from international tourism, best understood with local guidance.",
      access: "Flight or RN2 road from Antananarivo (350 km).",
      climate: "Rainy and humid; cyclone season January–March.",
      price: "Land from €4–12/m²; lagoon from €15/m².",
      best: "Residence, small tourism, port-related business.",
    },
  },
  {
    slug: "tulear", name: "Tuléar e Ifaty", pin: { x: 108, y: 645 },
    img: "https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=1200&q=75&auto=format&fit=crop",
    it: {
      tagline: "Il sud-ovest tra barriera corallina e baobab",
      profile: "Turismo balneare emergente",
      description: "Toliara (Tuléar) è la porta del sud-ovest: la laguna di Ifaty, la barriera corallina e le foreste di baobab. Clima secco e sole tutto l'anno.\n\nMercato meno maturo ma con prezzi interessanti per chi punta sulla crescita del turismo interno e internazionale.",
      access: "Volo da Antananarivo; strada RN7 panoramica.",
      climate: "Secco e soleggiato quasi tutto l'anno.",
      price: "Terreni da 3–10 €/m²; laguna da 12 €/m².",
      best: "Kite-resort, eco-turismo, pensione al sole.",
    },
    en: {
      tagline: "The south-west, between coral reef and baobabs",
      profile: "Emerging beach tourism",
      description: "Toliara (Tuléar) is the gateway to the south-west: the Ifaty lagoon, coral reef and baobab forests. Dry climate and sunshine all year.\n\nA less mature market with interesting prices for those betting on domestic and international tourism growth.",
      access: "Flight from Antananarivo; scenic RN7 road.",
      climate: "Dry and sunny almost all year.",
      price: "Land from €3–10/m²; lagoon from €12/m².",
      best: "Kite resorts, eco-tourism, retirement in the sun.",
    },
  },
  {
    slug: "fort-dauphin", name: "Fort-Dauphin", pin: { x: 240, y: 700 },
    img: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=1200&q=75&auto=format&fit=crop",
    it: {
      tagline: "Il fascino remoto del sud-est",
      profile: "Natura estrema e nicchie",
      description: "Taolagnaro (Fort-Dauphin) unisce montagne, foreste e oceano in un paesaggio unico. Zona remota, servita da un aeroporto e legata anche all'economia mineraria.\n\nPer investitori pazienti e progetti di nicchia: la logistica è la vera sfida.",
      access: "Volo da Antananarivo.",
      climate: "Variabile: piogge abbondanti, paesaggi verdi.",
      price: "Da valutare caso per caso; pochi annunci strutturati.",
      best: "Progetti di nicchia, eco-turismo d'avventura.",
    },
    en: {
      tagline: "The remote charm of the south-east",
      profile: "Extreme nature and niches",
      description: "Taolagnaro (Fort-Dauphin) combines mountains, forest and ocean in a unique landscape. A remote area, served by an airport and linked to the mining economy.\n\nFor patient investors and niche projects: logistics is the real challenge.",
      access: "Flight from Antananarivo.",
      climate: "Variable: heavy rainfall, green landscapes.",
      price: "Case by case; few structured listings.",
      best: "Niche projects, adventure eco-tourism.",
    },
  },
  {
    slug: "morondava", name: "Morondava", pin: { x: 118, y: 520 },
    img: "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=1200&q=75&auto=format&fit=crop",
    it: {
      tagline: "Il viale dei baobab e la costa ovest",
      profile: "Turismo iconico in crescita",
      description: "Morondava è la casa dell'Allée des Baobabs, l'immagine simbolo del Madagascar. Costa ovest con tramonti sull'oceano e turismo in crescita costante.\n\nTerreni costieri ancora accessibili: interessante per chi vuole essere dove il mondo sogna di andare.",
      access: "Volo da Antananarivo o pista 4x4.",
      climate: "Secco, caldo; stagione delle piogge breve.",
      price: "Terreni da 4–12 €/m²; costa da 15 €/m².",
      best: "Lodge, turismo fotografico, residenza.",
    },
    en: {
      tagline: "The Avenue of the Baobabs and the west coast",
      profile: "Growing iconic tourism",
      description: "Morondava is home to the Allée des Baobabs, Madagascar's iconic image. West coast with ocean sunsets and steadily growing tourism.\n\nCoastal land still affordable: interesting for those who want to be where the world dreams of going.",
      access: "Flight from Antananarivo or 4x4 track.",
      climate: "Dry, hot; short rainy season.",
      price: "Land from €4–12/m²; coast from €15/m².",
      best: "Lodges, photography tourism, residence.",
    },
  },
  {
    slug: "altopiani", name: "Altopiani agricoli", pin: { x: 158, y: 405 },
    img: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=75&auto=format&fit=crop",
    it: {
      tagline: "Il granaio del Madagascar",
      profile: "Agricoltura e allevamento",
      description: "Bongolava e Itasy sono le regioni agricole degli altipiani centrali: clima temperato, terre fertili, risaie a terrazza e pascoli. Prezzi al ettaro molto accessibili.\n\nPer chi vuole produrre: ortaggi, frutta, allevamento. Serve competenza agronomica e presenza o gestione locale affidabile.",
      access: "Strada da Antananarivo (2–4 ore).",
      climate: "Temperato d'altura; ideale per molte colture.",
      price: "Terreni agricoli da 0,3–1,5 €/m².",
      best: "Agricoltura, allevamento, agriturismo.",
    },
    en: {
      tagline: "Madagascar's breadbasket",
      profile: "Agriculture and livestock",
      description: "Bongolava and Itasy are the farming regions of the central highlands: temperate climate, fertile land, terraced rice fields and pastures. Very affordable per-hectare prices.\n\nFor those who want to produce: vegetables, fruit, livestock. Requires agronomic skill and presence or reliable local management.",
      access: "Road from Antananarivo (2–4 hours).",
      climate: "Temperate highland; ideal for many crops.",
      price: "Farmland from €0.3–1.5/m².",
      best: "Agriculture, livestock, agritourism.",
    },
  },
];
